"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  & > [data-meta='variable-text-editor'] {\n    position: absolute;\n    right: 0;\n    left: 0;\n    width: calc(100% + ", " * 2);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var editorPadding = '1.5rem';
exports.WrapperDiv = styled_components_1.default.div(_templateObject(), editorPadding);